import { render } from "./PredictiveAnalyticsContributionChart.vue?vue&type=template&id=3589dbe5"
import script from "./PredictiveAnalyticsContributionChart.vue?vue&type=script&lang=js"
export * from "./PredictiveAnalyticsContributionChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__